module.exports = __webpack_public_path__ + "static/img/JACK-CALLINAN.a1f65ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JACK-CALLINAN.jpg
// module id = f4ZL
// module chunks = 0